var React = require('react');

function BgHoverInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M124.83 18.1483L70.4 1.07282C66.56 -0.357606 61.44 -0.357612 57.6 1.07284L3.16958 18.1483C1.28841 18.6877 0 20.3428 0 22.2201V84.8302C0 92.9737 3.4495 101.31 10.2521 109.607C15.4476 115.945 22.6357 122.308 31.616 128.521C46.7024 138.959 61.5581 145.361 62.1832 145.629C62.7611 145.876 63.3809 146 64.0006 146C64.6203 146 65.2401 145.876 65.818 145.629C66.4428 145.361 81.2982 138.959 96.3846 128.521C105.365 122.308 112.553 115.945 117.748 109.607C124.551 101.31 128 92.974 128 84.8302V22.2201C128 20.3428 126.712 18.6877 124.83 18.1483Z","fill":"white"}));
}

BgHoverInline.defaultProps = {"width":"128","height":"146","viewBox":"0 0 128 146","fill":"none"};

module.exports = BgHoverInline;

BgHoverInline.default = BgHoverInline;
